import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteTankProfileResultDto } from 'src/app/interfaces/deleteTankProfileResponseDto';

@Component({
  selector: 'app-delete-failure-modal',
  templateUrl: './delete-failure-modal.component.html',
  styleUrls: ['./delete-failure-modal.component.css']
})
export class DeleteFailureModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DeleteTankProfileResultDto) { }
}
